import React from 'react'
import { AllowedAccess } from 'react-permission-role'
import { useLocation, useParams } from 'react-router-dom'
import { Card, CardContent, Button, Grid } from '@mui/material';

import { useFetchInitPaymentReception } from './hooks'
import { TablePaymentReception } from './TablePaymentReception'
import { FormPaymentReception } from './FormPaymentReception'
import { InfoVehicleReception } from './InfoVehicleReception'
import { ArrowLeft } from 'react-feather';

export const PaymentReception = () => {

    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFetchInitPaymentReception({location, paramsURL})

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        // Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

        // ------------------------------------------------ Generales
    // ------------------------------------------------ globalStates
    const { showForm } = globalStates
    // ------------------------------------------------ Helpers
    // ------------------------------------------------ Formularios
    // ------------------------------------------------ FetchData
    const { fetchInfoForVehicleReception } = FetchData
    const { dataInfoVehicleReception } = fetchInfoForVehicleReception
    // ------------------------------------------------ Actions
    const { handleClickShowForm, handleClickReturnToVehicleReception } = Actions

    return (
        <AllowedAccess permissions={['229_RECEPCION_DE_VEHICULOS']} renderAuthFailed={<p>Error</p>}>
            {(!showForm) && (
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Card style={{zIndex:'1'}}>
                            <CardContent>
                                <Button
                                    startIcon={<ArrowLeft/>}
                                    variant='text'
                                    color='error'
                                    size='large'
                                    sx={{ marginTop: 2, marginBottom : 2 }}
                                    onClick={handleClickReturnToVehicleReception}
                                >
                                    Volver a la pantalla anterior
                                </Button>
                                <div className="border-bottom border-dark"></div>
                                <div className='h4 mt-1 mb-1'> Pagos por predio judicial</div>
                                <div className="d-flex justify-content-end pt-4">
                                    <Button 
                                        style={{background: "#4b4b4c"}}
                                        variant="contained"
                                        type="button"
                                        onClick={() => handleClickShowForm(true)}
                                        disabled={
                                            ( (dataInfoVehicleReception[0]?.saldo_total || 0) === 0 )
                                                ? true
                                                : false
                                        }
                                    >
                                        <i className="fa-solid fa-plus"></i> &nbsp; Agregar
                                    </Button>
                                </div>

                                <InfoVehicleReception useFetchInit={useFetchInit} />
                                <div className="pt-4"></div>
                                <TablePaymentReception useFetchInit={useFetchInit} />
                                
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            )}
            {(showForm) && (
                <FormPaymentReception useFetchInit={useFetchInit} />
            )}
        </AllowedAccess>
    )
}
